import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter, Input } from '@angular/core';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { HecResponse } from '../..//shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../utilities/constants';
import { CommonHelper } from '../../../core/_config/common.helper';
import { SharedService } from '../../../shared/sharedServices/shared.service';
import { LoaderService } from '../../sharedServices/loader.service';
import { encrypt } from '../../../utilities/utilityFunctions';
import { Router } from '@angular/router';

@Component({
  selector: 'kt-profile-picture-update',
  templateUrl: './profile-picture-update.component.html',
  styleUrls: ['./profile-picture-update.component.scss']
})
export class ProfilePictureUpdateComponent implements OnInit {
  public loader:boolean=false;
  @Input() isImageAlert:boolean=false;
  private fileExt: string = 'jpg, jpeg, png';
  @Input() alertMsgValue:string;
  @Input() alertType:string;
  @Input() formType:any;
  private maxSize: number = 15360;
  private selectedFilePayload: any;
  private attachmentBase64: string;
  public profileAvatarImg: string;
  @Input() isImgAvailable: boolean = false;
  @Output() outputImg = new EventEmitter();
   public formView;
  public desUrls = HEC_CONSTANTS.DES_URLS;
  constructor(private cdr:ChangeDetectorRef,private ng2ImgMax: Ng2ImgMaxService,private sharedService:SharedService,
    private loaderService:LoaderService,public router:Router) { }

  ngOnInit() {
    this.getUserPicture()
  }

  // OLD CODE
  // public async changeFileSelection(e: FileList) {
  //   let image = e[0];
  //   let test: File;
  //   const file = e[0];
  //   if (this.isValidFile(file)) {
  //     this.loader = true;
  //     this.loaderService.setValue(this.loader)
  //     this.cdr.detectChanges();
  //     this.ng2ImgMax.compressImage(image, 0.575).subscribe(
  //       async result => {
  //         test = result;
  //         await this.setAttachmentsPayload(result);
  //         this.uploadAttachment();

  //       },
  //       error => {
  //         console.log('error', error);
  //         this.loader = false;
  //         this.loaderService.setValue(this.loader)
  //       }
  //     );
  //   }
  // }

  // NEW CODE
  // Change file selection
  public async changeFileSelection(files: FileList) {
    const file = files[0];
  
    if (!file || !this.isValidFile(file)) {
      return;
    }
  
    const isPassportSize = await this.validatePassportPhoto(file);
  
    if (!isPassportSize) {
      this.alertType = 'warning';
      this.alertMsgValue = 'Please upload a passport-size photo (35x45 ratio).';
      this.cdr.detectChanges();
      this.sharedService
      .openPopupDialog(
        'Error',
        'Please upload a passport-size photo (35x45 ratio). Photograph must be taken against a white background with dimensions not less than 350 x 467.',
        HEC_CONSTANTS.ERROR_TYPES.warning
      )
      .then((res) => {
      });
      this.cdr.detectChanges();
      return;
    }
  
    this.loader = true;
    this.loaderService.setValue(this.loader);
    this.cdr.detectChanges();
  
    this.ng2ImgMax.compressImage(file, 0.575).subscribe(
      async result => {
        await this.setAttachmentsPayload(result);
        this.uploadAttachment();
      },
      error => {
        console.error(error);
        this.loader = false;
        this.loaderService.setValue(this.loader);
      }
    );
  }

  // NEW CODE 
  // Validate passport photo size and ratio
  private validatePassportPhoto(file: File): Promise<boolean> {
    return new Promise((resolve) => {
      const img = new Image();
  
      img.onload = () => {
        const width = img.width;
        const height = img.height;
  
        // Passport photo ratio: 35 / 45 = 0.7778
        const ratio = width / height;
        const passportRatio = 35 / 45;
  
        const tolerance = 0.05;
  
        resolve(
          Math.abs(ratio - passportRatio) <= tolerance &&
          width >= 300 &&
          height >= 400
        );
      };
  
      img.onerror = () => resolve(false);
      img.src = URL.createObjectURL(file);
    });
  }

  private isValidFile(file) {
    const extensions = (this.fileExt.split(',')).map(function (x) { return x.toLocaleLowerCase().trim(); }); // array of extensions
    const ext = file.name.toLowerCase().split('.').pop() || file.name;
    const fileSizeinKB = file.size / 1024;
    if (extensions.indexOf(ext) === -1) {
      // this.isImageAlert = true;
      this.sharedService
          .openPopupDialog(
            'Error',
            'Error in uploading ' + file.name + ' due to invalid file type.',
            HEC_CONSTANTS.ERROR_TYPES.error
          )
          .then((res) => {
          });
      this.alertMsgValue = 'Error in uploading ' + file.name + ' due to invalid file type.'
      this.alertType = 'warning';
      this.cdr.detectChanges();
      // setTimeout(() => {
      //   this.isImageAlert = false;
      //   this.cdr.detectChanges();
      // }, 3000);
      return false;
    } else if (!file.name.match(HEC_CONSTANTS.CONSTANT_VALUES.fileAllowedFormat)) {
      // this.isImageAlert = true;
      this.alertType = 'warning';
      this.alertMsgValue = 'Invalid File Name'
      this.cdr.detectChanges();
      this.sharedService
      .openPopupDialog(
        'Error',
        'Invalid File Name',
        HEC_CONSTANTS.ERROR_TYPES.error
      )
      .then((res) => {
      });
      // setTimeout(() => {
      //   this.isImageAlert = false;
      //   this.cdr.detectChanges();
      // }, 3000);
      return false;
    }
    else if (fileSizeinKB > this.maxSize) {
      // this.isImageAlert = true
      this.alertType = 'warning';
      this.alertMsgValue = file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.'
      this.sharedService
      .openPopupDialog(
        'Error',
        file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.',
        HEC_CONSTANTS.ERROR_TYPES.error
      )
      .then((res) => {
      });
      this.cdr.detectChanges();
      // setTimeout(() => {
      //   this.isImageAlert = false;
      //   this.cdr.detectChanges();
      // }, 3000);
      return false;
    }
    return true;
  }

  private async setAttachmentsPayload(file) {
    this.attachmentBase64 = (await this.convertFileToBase64(file)).toString();
  }

  private uploadAttachment() {    
    this.selectedFilePayload = '';
    this.selectedFilePayload = this.attachmentBase64;
    
    let payload = {
      data: this.selectedFilePayload
    }
    this.sharedService.postUpdateProfilePicture(payload)
      .subscribe(
        (res:HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.isImageAlert=false;
            this.getUserPicture();
            this.cdr.detectChanges();
          }
          else{
            // this.ale
          }
          this.loader = false;
      this.loaderService.setValue(this.loader)
        },
        (err) => {
      // this.isImageAlert = true;
      this.sharedService
      .openPopupDialog(
        'Error',
        'Error in uploading profile picture',
        HEC_CONSTANTS.ERROR_TYPES.error
      )
      .then((res) => {
      });
      this.alertType = 'error';
      this.alertMsgValue = 'Error in uploading profile picture';
      this.loader = false;
      this.loaderService.setValue(this.loader)
      this.cdr.detectChanges();
          console.log(err)
        }
      )
  }
  private convertFileToBase64(file): any {
    return new Promise((resolve, reject) => {
      CommonHelper.convertFileToBase64(file).then((result) => {
        resolve(result);
      })
        .catch(function (error) {
          console.log(error)
          resolve(null);
        })
    })
  }

  public getUserPicture() {
    this.sharedService.getUserProfilePicture().subscribe(
      (res: HecResponse) => {
        if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          if (res.data != "") {
            this.profileAvatarImg = res.data;
            this.isImgAvailable = true;
            this.isImageAlert = false;
            this.loader = false;
            this.outputImg.emit(res.data)
            localStorage.removeItem('Avatar')
            localStorage.setItem('Avatar', encrypt(res.data))
            this.cdr.detectChanges();
          } else {
            this.profileAvatarImg = '/assets/media/users/default.jpg';
            this.cdr.detectChanges();
          }
        }
      }
    )
    }
}
